/** Data-freshness labels for the Client / Broker filter bars. */

/** Full ingest timestamp, "MM/DD/YYYY hh:mm AM/PM" (em dash if absent). Tooltip text. */
export const formatIngestTs = (iso: string | null): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const date = d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  const time = d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
  return `${date} ${time}`;
};

/**
 * Compact age since ingest — "14m", "3h", "2d". The full timestamp moves to the
 * tooltip so the filter bar stays one line.
 *
 * A future timestamp reads "0m" rather than a negative: clock skew between the
 * browser and the warehouse is the likely cause, and "-3m old" looks like a bug.
 */
export const formatIngestAge = (iso: string | null, now: Date = new Date()): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const mins = Math.max(0, Math.floor((now.getTime() - d.getTime()) / 60000));
  if (mins < 60) return `${mins}m`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
};
